import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import '../css/ManageParticipants.css';
import api from '../utils/axiosConfig';

function ManageParticipants() {
  const [participants, setParticipants] = useState([]);
  const [filteredParticipants, setFilteredParticipants] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchParticipants = async () => {
      try {

        const response = await api.get('/api/participants');
        const data =  response.data;
        
        // Ensure all participants have required fields
        const sanitizedParticipants = data.map(participant => ({
          _id: participant._id || '',
          name: participant.name || '',
          code: participant.code || '',
          active: participant.active || false
        }));
        
        setParticipants(sanitizedParticipants);
        setFilteredParticipants(sanitizedParticipants);
      } catch (err) {
        setError("Failed to load participants");
      } finally {
        setLoading(false);
      }
    };
    fetchParticipants();
  }, []);

  // Filter participants based on search term
  useEffect(() => {
    if (searchTerm.trim() === '') {
      setFilteredParticipants(participants);
    } else {
      const term = searchTerm.toLowerCase();
      const filtered = participants.filter(participant => {
        const name = participant.name ? participant.name.toLowerCase() : '';
        const code = participant.code ? participant.code.toLowerCase() : '';
        return name.includes(term) || code.includes(term);
      });
      setFilteredParticipants(filtered);
    }
  }, [searchTerm, participants]);

  const handleDelete = async (id) => {
    if (!window.confirm('Sind Sie sicher, dass Sie diesen Teilnehmer löschen möchten?')) return;
    
    try {
      await api.delete(`/api/participants/${id}`);
      setParticipants(participants.filter(participant => participant._id !== id));
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to delete participant');
    }
  };

  const handleStatusToggle = async (id) => {
    try {
      const { data } = await api.patch(`/api/participants/${id}/status`);
        setParticipants(participants.map(participant => 
          participant._id === id ? { ...participant, active: data.active } : participant
      ));
    } catch (err) {
      //setError(err.message);
      setError(err.response?.data?.message || 'Failed to update status');
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="error-message">{error}</p>;

  return (
    <div className="manage-container">
      <div className="manage-header">
        <h1>Teilnehmer</h1>
        <div className="search-container">
          <input
            type="text"
            placeholder="Nach Name oder Code suchen..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <span className="search-results-count">
            {filteredParticipants.length} von {participants.length} Teilnehmern
          </span>
        </div>
      </div>
      <div className="manage-table-wrapper">
      <table className="manage-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Name</th>
            <th>Status</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {filteredParticipants.length > 0 ? (
            filteredParticipants.map((p) => (
              <tr key={p._id}>
                <td>{p.code || '-'}</td>
                <td>{p.name || '-'}</td>
                <td>
                  <span className={`status ${p.active ? 'active' : 'inactive'}`}>
                    {p.active ? 'Aktiv' : 'Inaktiv'}
                  </span>
                </td>
                <td className="actions">
                  <button 
                    onClick={() => handleStatusToggle(p._id)}
                    className={`status-button ${p.active ? 'deactivate' : 'activate'}`}
                  >
                    {p.active ? 'Deaktivieren' : 'Aktivieren'}
                  </button>
                  <button 
                    className="edit-button"
                    onClick={() => navigate(`/dashboard/participants/${p._id}/edit`)}
                  >
                    Bearbeiten
                  </button>
                  <button 
                    className="delete-button"
                    onClick={() => handleDelete(p._id)}
                  >
                    Löschen
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" className="no-results">
                Keine Teilnehmer gefunden
              </td>
            </tr>
          )}
        </tbody>
      </table>
      </div>
    </div>
  );
}

export default ManageParticipants;